import React from 'react'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import Form from 'react-bootstrap/Form';
import ModalItem from '../../components/ModalItem';
import { deleteRequest, getRequest,  } from '../../http';
import { Admi } from './admin_menu.styled';
import del from '../assets/media/delete.svg'
import { Outlet, useNavigate } from 'react-router-dom';
import PlusSvg from '../assets/beehive/PlusSvg';
import logo from '../assets/custom.webp'
import { ref, deleteObject } from "firebase/storage";
import { storage } from '../../firebase_config';


export default function AdminMenu() {

  const [modalShow, setModalShow] = React.useState(false);
  const [show, setShow] = React.useState(false);
  const [items, setItems] = React.useState([]);
  const [state, setState] = React.useState('');
  const [filTyp, setFilTyp] = React.useState('');
  const [filCat, setFilCat] = React.useState('');
  const [load, setLoad] = React.useState(false);
  const [delOBJ, setDelOBJ] = React.useState({});
  const filtypes = ['Food', 'Drinks', 'Tobacco', 'Bookings']
  const navigate = useNavigate()

  
   
  const onConfirm = (id, name,img_id)=>{
    setDelOBJ({id: id, name: name,img_id: img_id})
    setShow(true)
  }
  const onDelete = ()=>{
    
    setLoad(true)
    const deleteItem = ref(storage, delOBJ.img_id)
   

    deleteRequest(`/del_item/${delOBJ.id}`, (resp)=>{
      console.log(resp.data)
      if(resp.data.success){
        deleteObject(deleteItem).then(()=>{
          console.log('Image deleted Successfully')
        }).catch((error)=>{
          console.log(error)
        })
      }
    }).finally(()=>{
      setLoad(false)
      setShow(false)
      setState(delOBJ.id)
      setDelOBJ({})
    })
    
  }
  
  const onEdit = async (data)=>{
    localStorage.setItem('item', JSON.stringify(data))
    navigate('edit')
  }
  
  React.useEffect(()=>{
    getRequest('/get_item', (resp)=>{
      const data = resp.data.results
      if(data?.auth?.name === 'JsonWebTokenError'){
        navigate('/sign-in')
      }else{
        setItems(data)
      }
      
    })

    
  },[state, navigate])

  console.log(items)
  return (
    <div>
      <Modal
      show={show}
      centered
      backdrop='static'
      onHide={() => setShow(false)}
      >
        <Modal.Body>
          <h5>Confirm the deletion of <i style={{color: '#a00'}}>{delOBJ.name}</i></h5>
        </Modal.Body>
        <Modal.Footer className="btns-del">
          
          <Button onClick={()=>{setShow(false); setDelOBJ({})}} variant='info'>Cancel</Button>
          <Button onClick={onDelete} variant='danger'><Spinner
           animation='border'
           style={{display: !load ? 'none' : 'contents'}}
           size='sm'
           variant='dark'
           /> Confirm</Button>
           
        </Modal.Footer>
      </Modal>
      <ModalItem
       show={modalShow}
       onHide={() => setModalShow(false)}
       reloadData={(id)=>setState(id)}
      />
      
      <Admi>
        <section className="header">
          <img height={'90px'} src={logo} alt="" />
          <h2>Admin</h2>
        </section>
        <section className='menu-filt'>
          <Button  onClick={() => setModalShow(true)}><PlusSvg/> New Item</Button>
           
          <div className="menu-inwrap">
          
          <div className='opt'>
          <span>
          <Form.Label>Types</Form.Label><br/>
          <Form.Select onChange={(e)=>{setFilTyp(e.target.value); setFilCat('')}} name="type" id="">
           <option  value=''>All</option>
           {filtypes?.map((item, i)=>{
            return <option value={item} key={i}>{item}
            </option>
           })}
          </Form.Select>
          </span>
          <span style={{marginLeft: '20px'}}>
          <Form.Label>Category</Form.Label><br/>
          <Form.Select onChange={(e)=>setFilCat(e.target.value)} name="cat" id="">
           <option value="">All</option>
           {[...new Set(items.map((val,i)=>val.type.match(filTyp) && val.category))]?.map((item, i)=>{
            return item !== null &&  <option value={item} key={i}>{item}
            </option>
           })}
          </Form.Select>
          </span>
          </div>
          <div className="sear">
            <Form.Control
            type='search'
            placeholder='Search by Name'
            ></Form.Control>
          </div>
          </div>
        </section>
      <section className="table">
       

     
        <table>
          <thead>
            <tr>
              <th>Image</th>
              <th>Name</th>
              <th>Description</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            {items?.map((item, i)=>{
              return item?.type.match(filTyp) && item?.category.match(filCat) && <tr key={i}>
                <td style={{ paddingLeft: '3px', paddingRight: '5px'}}><Button onClick={()=>onConfirm(item?._id, item?.name, item?.image_id)} style={{zIndex: '500',padding: '5px'}} variant='danger'><img src={del} alt="" /></Button> <img height={'45px'} style={{maxWidth: '80px'}} src={item?.image_url} alt="" /></td>
               
                <td onClick={()=>onEdit(item)}>{item?.name}</td>
                <td onClick={()=>onEdit(item)} className='desc'>{item?.description} </td>
                <td onClick={()=>onEdit(item)}>R {item?.price}</td>
                
              </tr>
            })}
          </tbody>
        </table>
      </section>
      <div className="out">
        <Outlet/>
      </div>
      </Admi>
    </div>
  )
}
